import React from 'react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles((theme) => ({
   button: {
      backgroundColor: '#27A844',
      color: 'white',
   },
}));

const Download = (
   props = {
      isLoading: false,
   },
) => {
   const classes = useStyles();
   return (
      <Button
         disabled={props.isLoading}
         {...props}
         variant={'contained'}
         className={classes.button}
         startIcon={
            props.isLoading ? (
               <CircularProgress size={20} color={'primary'} />
            ) : (
               <FontAwesomeIcon icon={faFileExcel} size={'xs'} />
            )
         }
         target='_blank'
      >
         ดาวน์โหลดข้อมูลทั้งหมด (ปีปัจจุบัน)
      </Button>
   );
};
export default Download;
